const fromdata = [
	{
			inputdata: '',
			title: '父级',
			fontSize: '14px',
			color: '#333333',
			placeholder: '请输入',
			types: 'text',
			inputtype: 'input',
			width: '300px',
			disabled: false,
			// lablewith: '90px',
			btx: false,
		},{
			inputdata: '',
			title: '编号',
			fontSize: '14px',
			color: '#333333',
			placeholder: '请输入',
			types: 'text',
			inputtype: 'input',
			width: '300px',
			disabled: false,
			// lablewith: '90px',
			btx: false,
		},{
			inputdata: '',
			title: '名称',
			fontSize: '14px',
			color: '#333333',
			placeholder: '请输入',
			types: 'text',
			inputtype: 'input',
			width: '300px',
			disabled: false,
			// lablewith: '90px',
			btx: true,
		},{
			inputdata: '',
			title: '产品线',
			fontSize: '14px',
			color: '#333333',
			placeholder: '全部',
			types: '',
			inputtype: 'select',
			width: '310px',
			btx: true,
			// lablewith: '90px',
			options: [{
				key: "1",
				value: "正在",
			},
			{
				key: "2",
				value: "进行中。。。",
			}]
		},
]
export default fromdata;
